import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RcFile } from 'antd/es/upload';

import { ECreateOfferStages, TOfferForm } from 'entities/Offer';

interface IOfferSliceSlice {
	aiMarkdown: string;
	contractor: string;
	createStage: ECreateOfferStages;
	formValues: TOfferForm | null;
	attachments: RcFile[];
	offerType: string;
}

const initialState: IOfferSliceSlice = {
	aiMarkdown: '',
	contractor: '',
	createStage: ECreateOfferStages.GENERATE,
	formValues: null,
	attachments: [],
	offerType: 'public'
};

export const offerSlice = createSlice({
	name: 'task',
	initialState,
	reducers: {
		addAttachments: (state, action: PayloadAction<RcFile>) => {
			state.attachments.push(action.payload);
		},
		clearAll: (state) => {
			state.aiMarkdown = '';
			state.contractor = '';
			state.formValues = null;
			state.attachments = [];
			state.createStage = ECreateOfferStages.GENERATE;
		},
		setAIMarkdown: (state, action: PayloadAction<string>) => {
			state.aiMarkdown = action.payload;
		},
		setCreateStage: (state, action: PayloadAction<ECreateOfferStages>) => {
			state.createStage = action.payload;
		},
		setContractor: (state, action: PayloadAction<string>) => {
			state.contractor = action.payload;
		},
		setFormValues: (state, action: PayloadAction<TOfferForm>) => {
			state.formValues = action.payload;
		},
		setOfferType: (state, action: PayloadAction<string>) => {
			state.offerType = action.payload;
		}
	},
});

export default offerSlice.reducer;
export const { addAttachments, clearAll, setAIMarkdown, setCreateStage, setFormValues, setContractor, setOfferType } =
	offerSlice.actions;
